const AdditionalDataTypes = {
    ADDITIONALDETAILS_ACTION_START:"ADDITIONALDETAILS_ACTION_START",
    ADDITIONALDETAILS_FETCH_DATA:"ADDITIONALDETAILS_FETCH_DATA",
    ADDITIONALDETAILS_FETCH_DATA_FAILED:"ADDITIONALDETAILS_FETCH_DATA_FAILED",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
}

const AdditionalOtherDetailsReducer = (state=Initial_state, action) => {
    switch(action.type){
        case AdditionalDataTypes.ADDITIONALDETAILS_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case AdditionalDataTypes.ADDITIONALDETAILS_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload,
            }

        case AdditionalDataTypes.ADDITIONALDETAILS_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export default AdditionalOtherDetailsReducer;